
import React, {useState, useRef, useEffect} from 'react';
import {useId} from 'react';
import {createPortal} from 'react-dom';
import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from "react-tooltip";
import useCopyToClipboard from '../hooks/useCopyToClipboard';
import Button from 'react-bootstrap/Button';
import 'react-tooltip/dist/react-tooltip.css';

import {APP_COLORS} from "../Constants";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-regular-svg-icons'

import styled from "styled-components";

const TextHoverDisplay = (props) => {

  const {
      truncatedText,
      fullText,
      toolTipTextColor,
      toolTipBackgroundColor,
      displayTruncated,
      canShowText=true,
      canShowCopyToClipboard=true,
      minWidth=125,
  } = props;

  const { copied, copyToClipboard } = useCopyToClipboard();
  const tooltipId = useId();
  const copyButtonRef = useRef(null);
  const [pillPosition, setPillPosition] = useState({ top: 0, left: 0 });

  // Position the copied pill next to the copy icon
  useEffect(() => {
    if (copied && copyButtonRef.current) {
      requestAnimationFrame(() => {
        const rect = copyButtonRef.current?.getBoundingClientRect();
        if (rect) {
          setPillPosition({
            top: rect.top + rect.height / 2,
            left: rect.left + rect.width + 10
          });
        }
      });
    }
  }, [copied]);

  return (
      <div style={{minWidth: minWidth, maxWidth: '140px', overflow: 'visible', position: 'relative'}}>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative'}}>
          {canShowText && (
              <div
                  data-tooltip-id={tooltipId}
                  data-tooltip-content={fullText}
                  data-tooltip-place="top"
                  style={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '100px'}}>
                  {displayTruncated ?
                      <span>{`${truncatedText}...`}&nbsp;</span>
                      :
                      <span>{`${fullText}`}&nbsp;</span>
                  }
              </div>)}
              {canShowCopyToClipboard &&(
              <div ref={copyButtonRef} style={{position: 'relative', display: 'inline-flex', alignItems: 'center'}}>
                  <div 
                      data-tooltip-id='copiedText' 
                      data-tooltip-content={'copied'}
                      onClick={() => copyToClipboard(fullText)}
                      style={{ cursor: 'pointer' }}
                  >
                    <WrapperFontAwesomeIcon icon={faCopy} />
                  </div>
              </div>)}
              
          </div>
          { copied && createPortal(
              <TagCopiedFixed style={{
                top: `${pillPosition.top}px`,
                left: `${pillPosition.left}px`,
                transform: 'translateY(-50%)'
              }}>
                Copied!
              </TagCopiedFixed>,
              document.body
          )}
          <ReactTooltip
              id={tooltipId}
              place="top"
              variant="dark"
              positionStrategy="fixed"
              style={{
                  zIndex: 200000,
                  color: toolTipTextColor ? toolTipTextColor : undefined,
                  backgroundColor: toolTipBackgroundColor ? toolTipBackgroundColor : undefined
              }}
          />

          {/*<ReactTooltip*/}
              {/*id='copiedText'*/}
              {/*getContent={(dataTip) => copied ? `${dataTip}` : undefined}*/}
              {/*textColor={toolTipTextColor ? toolTipTextColor : undefined}*/}
              {/*backgroundColor={toolTipBackgroundColor ? toolTipBackgroundColor : undefined}*/}
          {/*/>*/}

      </div>
  )
};

TextHoverDisplay.defaultProps = {
    displayTruncated: true,
};

TextHoverDisplay.propTypes = {
    displayTruncated: PropTypes.bool,
    truncatedText: PropTypes.string,
    fullText: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    toolTipTextColor: PropTypes.string,
    toolTipBackgroundColor: PropTypes.string,
};

const WrapperFontAwesomeIcon = styled(FontAwesomeIcon) `
  color: ${APP_COLORS.blue};
  cursor: pointer;
  
  &:hover {
    color: ${APP_COLORS.orange};
  }
  
  &:active {
    color: ${APP_COLORS.cyan};
  }
`;

const TagCopiedFixed = styled.div `
  padding: 3px 15px;
  background-color: ${APP_COLORS.orange};
  border-radius: 5px;
  color: white;
  font-weight: 600;
  font-size: 12px;
  box-shadow: rgb(60 64 67 / 30%) 0 1px 2px 0, rgb(60 64 67 / 15%) 0 1px 3px 1px;
  position: fixed;
  z-index: 200000;
  white-space: nowrap;
  pointer-events: none;
`;

export default TextHoverDisplay;
